import { Link } from "react-router-dom";
import "./LabPage.css";

export default function LabPage() {
  return (
    <div className="lab-page">
      <header className="lab-page__header">
        <Link to="/" className="lab-page__logo">
          DYLAN CHEN ZHEN
        </Link>
        <nav className="lab-page__nav">
          <Link to="/projects" className="lab-page__nav-link">
            Projects
          </Link>
          <Link to="/about" className="lab-page__nav-link">
            About
          </Link>
        </nav>
      </header>

      <section className="lab-page__intro">
        <span className="lab-page__eyebrow">Lab</span>
        <h1 className="lab-page__title">Lab</h1>
        <p className="lab-page__subtitle">
          Experiments and prototypes will appear here.
        </p>
        <Link
          to="/solar-lab"
          style={{
            display: "inline-block",
            marginTop: "1.5rem",
            padding: "0.5rem 1.5rem",
            borderRadius: "100px",
            border: "1px solid rgba(200, 215, 255, 0.15)",
            background: "rgba(200, 215, 255, 0.04)",
            color: "rgba(200, 215, 255, 0.75)",
            fontSize: "0.75rem",
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            textDecoration: "none",
            transition: "background 0.25s ease, color 0.25s ease",
          }}
        >
          Solar Worlds — 20 Procedural Planets
        </Link>
      </section>
    </div>
  );
}
